/**
 * Copyright 2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import React from 'react';

export interface IGaugeProps {
  min: number;
  max: number;
  amount: number;
  showedValue?: ShowedValue;
}

export enum ShowedValue {
  None = 0, Percent, Absolute
}

export default function Gauge (props: IGaugeProps) {
  const min = Number(props.min);
  const max = Number(props.max);
  const amountAbs = props.amount !== undefined ? Number(props.amount) : 0;
  const amountRel = (amountAbs - min) / (max - min);
  const amountPerc = amountRel * 100;
  /* Chrome will render nothong when start == end, so we leave a tiny little bit out */
  const amountRad = Math.min(0.9999, Math.max(0, amountRel)) * Math.PI;

  const x = Math.sin(amountRad - Math.PI / 2) * 50;
  const y = -Math.cos(amountRad - Math.PI / 2) * 50;

  const long = amountRad > Math.PI ? 1 : 0; // Long/ Short drawing ot the elipse

  /* <!-- Die letzten beiden Zahlen sind die Zielunkte auf dem Außenkreis (absolut)  --> */
  const path = 'M0,0 h-50 A 50,50 0 ' + long + ' 1 ' + x + ' ' + y + ' z';

  let amountPercStr = amountPerc > 99.9 ? Math.round(amountPerc) : amountPerc.toFixed(1);
  amountPercStr += '%';
  const showedValue = props.showedValue ? props.showedValue : ShowedValue.None;
  let value: string | number | null = null;
  switch (showedValue) {
    case ShowedValue.Absolute:
    {
      value = amountAbs > 99 ? Math.round(amountAbs) : amountAbs.toFixed(1);
      break;
    }
    case ShowedValue.Percent:
    {
      value = amountPercStr;
    }
  }
  return (
    <svg className="gauge" viewBox="-50 -50 100 70" xmlns="http://www.w3.org/2000/svg">

      <defs>
        <mask id="innerCircle" x="0" y="0" width="100" height="100">
          <circle className="outer" cx="0" cy="0" r="50" strokeWidth="0" fill="white" />
          <circle className="outer" cx="0" cy="0" r="37" strokeWidth="0" fill="black" />
          <rect x="-50" y="0" width="100" height="50" strokeWidth="0" fill="black" />
        </mask>
        <linearGradient id="umati_gradient" x1="35.35" y1="-35.35" x2="-35.35" y2="35.35" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#18c5f4" />
          <stop offset="1" stopColor="#fb3099" />
        </linearGradient>
      </defs>

      <g mask="url(#innerCircle)">
        <circle className="outer" cx="0" cy="0" r="50" strokeWidth="0" fill="#eaeaea" />
        <path fill="url(#umati_gradient)" d={path} />
      </g>
      {value !== null && <text x="0" y="0" textAnchor="middle" dy="0.3em" fontSize="16px" fontWeight="bold">{value}</text>}
    </svg>
  );
}
